import React from 'react';
import { Box } from '@mui/material';
import teaserImage from '../../../assets/images/teaser-md.webp';

type AuthSplitLayoutProps = {
  children: React.ReactNode;
};

/** Shared login / recover / reset shell: form column + brand teaser panel. */
const AuthSplitLayout: React.FC<AuthSplitLayoutProps> = ({ children }) => (
  <Box
    component="main"
    sx={{
      display: 'flex',
      minHeight: '100vh',
    }}
  >
    <Box
      sx={{
        flex: { xs: '1 1 100%', md: '596 1 0' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Keep side padding at md+: left column can be <420px when teaser shows (~900-1100px).
        px: { xs: 2, md: 3 },
        py: { xs: 4, md: 0 },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 420,
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        {children}
      </Box>
    </Box>

    <Box
      sx={{
        display: { xs: 'none', md: 'flex' },
        flex: '828 1 0',
        // No left padding - form column already has padding
        py: 2,
        pr: 2,
      }}
    >
      <Box
        sx={{
          flex: 1,
          borderRadius: '16px',
          background: (theme) =>
            `linear-gradient(to bottom, ${theme.palette.primary.main}, ${theme.palette.secondary.light})`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          p: { md: 3, lg: 4 },
        }}
      >
        <Box
          component="img"
          src={teaserImage}
          alt="MarketSmart user-interface promo"
          sx={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
    </Box>
  </Box>
);

export default AuthSplitLayout;
